const App = {
  SetBackground: () => {
    $("[setBackground]").each(function () {
      var background = $(this).attr("setBackground");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-size": "cover",
        "background-position": "center center",
      });
    });
    $("[setBackgroundRepeat]").each(function () {
      var background = $(this).attr("setBackgroundRepeat");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-repeat": "repeat",
      });
    });
  },
  EqualHeightElement: (el) => {
    let height = 0;
    let thisHeight = 0;
    $(el).each(function () {
      thisHeight = $(this).height();
      if (thisHeight > height) {
        height = thisHeight;
      }
    });
    $(el).height(height);
  },
  ScrollTo: (y) => {
    $("html, body").animate(
      {
        scrollTop: y,
      },
      1000
    );
  },
  Init: () => {
    App.ScrollTo();
    App.SetBackground();
  },
};

function InitSlider() {
  var heroBanner = new Swiper(".hero-banner .swiper-container", {
    speed: 1600,
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    autoplay: {
      delay: 7000,
    },
    navigation: {
      clickable: !0,
      nextEl: ".hero-banner .swiper-next",
      prevEl: ".hero-banner .swiper-prev",
    },
  });
  var navSlide = new Swiper(".nav-slide .swiper-container", {
    speed: 1e3,
    slidesPerView: 4,
    spaceBetween: 40,
    slidesPerColumn: 2,
    breakpoints: {
      1025: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
    navigation: {
      clickable: !0,
      nextEl: ".nav-slide .swiper-next",
      prevEl: ".nav-slide .swiper-prev",
    },
  });
  var meetOurCollectons = new Swiper(
    ".meet-our-collections .swiper-container",
    {
      speed: 1e3,
      slidesPerView: 2,
      spaceBetween: 40,
      autoplay: {
        delay: 5000,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
      navigation: {
        clickable: !0,
        nextEl: ".meet-our-collections .swiper-next",
        prevEl: ".meet-our-collections .swiper-prev",
      },
    }
  );
  var productSlide = new Swiper(".product-slide .swiper-container", {
    speed: 1e3,
    slidesPerView: 4,
    spaceBetween: 40,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
    navigation: {
      clickable: !0,
      nextEl: ".product-slide .swiper-next",
      prevEl: ".product-slide .swiper-prev",
    },
  });
  var ourProducts = new Swiper(".our-products .swiper-container", {
    speed: 1e3,
    slidesPerView: 4,
    spaceBetween: 40,
    breakpoints: {
      1025: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
      },
    },
    navigation: {
      clickable: !0,
      nextEl: ".our-products .swiper-next",
      prevEl: ".our-products .swiper-prev",
    },
  });
  var artistBlog = new Swiper(".artist-blogs .swiper-container", {
    speed: 1e3,
    slidesPerView: 3,
    spaceBetween: 40,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
    navigation: {
      clickable: !0,
      nextEl: ".artist-blogs .swiper-next",
      prevEl: ".artist-blogs .swiper-prev",
    },
  });
  var discoverMore = new Swiper(".discover-more .swiper-container", {
    speed: 1e3,
    slidesPerView: 4,
    spaceBetween: 40,
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
      },
    },
    navigation: {
      clickable: !0,
      nextEl: ".discover-more .swiper-next",
      prevEl: ".discover-more .swiper-prev",
    },
  });
  var moreToLove = new Swiper(".more-to-love .swiper-container", {
    speed: 1e3,
    slidesPerView: 4,
    spaceBetween: 40,
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
    navigation: {
      clickable: !0,
      nextEl: ".more-to-love .swiper-next",
      prevEl: ".more-to-love .swiper-prev",
    },
  });

  var lmopSlide = new Swiper(".lets-make-ome-polls .swiper-container", {
    speed: 1e3,
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      clickable: !0,
      nextEl: ".lets-make-ome-polls .swiper-next",
      prevEl: ".lets-make-ome-polls .swiper-prev",
    },
  });
  var instagramSlide = new Swiper(".instagram-slide .swiper-container", {
    speed: 1e3,
    slidesPerView: 5,
    spaceBetween: 0,
    breakpoints: {
      1025: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
    },
    navigation: {
      clickable: !0,
      nextEl: ".instagram-slide .swiper-next",
      prevEl: ".instagram-slide .swiper-prev",
    },
  });
  if ($(".product-detail").length) {
    var galleryThumbs = new Swiper(".gallery-thumbs", {
      spaceBetween: 40,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
    var galleryTop = new Swiper(".gallery-top", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });
  }
  var numSlick = 0;
  $(".slick1").each(function () {
    numSlick++;
    $(this)
      .addClass("slider-" + numSlick)
      .slick({
        infinite: true,
        dots: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $(this).parent(".nav-slide").find(".swiper-prev"),
        nextArrow: $(this).parent(".nav-slide").find(".swiper-next"),
      });
  });
}

function Headers() {
  $(document).on("click", ".toggle-btn", function () {
    $(this).toggleClass("active");
    $(".header").toggleClass("show");
    $(".header .mobile-nav-inner").toggleClass("active");
    $(".back-drop").toggleClass("active");
  });
  $(document).on("click", ".close-btn", function () {
    $(".cart-panel").removeClass("show");
    $(".cart-overlay").removeClass("active");
  });
  $(document).on("click", ".cart-toggle", function () {
    $(".cart-panel").toggleClass("show");
    $(".cart-overlay").addClass("active");
  });
  $(document).on("click", ".mobile-nav-inner li.has-dropdown>a", function () {
    $(this).toggleClass("active").next().slideToggle();
  });
  $(window).on("resize", function () {
    $("header .mobile-nav-inner").removeClass("active");
    $("body").removeClass("over-hidden");
    $(".back-drop,.cart-overlay").removeClass("active");
    $(".cart-panel").removeClass("show");
    $(".toggle-btn").removeClass("active");
  });
  $(document).on("click", ".back-drop,.cart-overlay", function () {
    $(this).removeClass("active");
    $(".header .mobile-nav-inner").removeClass("active");
    $(".search-wrapper").removeClass("active");
    $(".toggle-btn").removeClass("active");
    $(".cart-panel").removeClass("show");
  });
  $(document).on("click", ".mb-filter", function () {
    $(this).toggleClass("active");
    $(".sidebar").slideToggle();
  });
}
//mapping
function mappings() {
  var moveLogo = new MappingListener({
    selector: "header .logo",
    mobileWrapper: ".header .header-bottom .wrapper .toggle-btn",
    mobileMethod: "insertAfter",
    desktopWrapper: "header .header-middle",
    desktopMethod: "appendTo",
    breakpoint: 1025,
  }).watch();
  var moveNav = new MappingListener({
    selector: "header .menu",
    mobileWrapper: ".mobile-nav-inner",
    mobileMethod: "appendTo",
    desktopWrapper: "header .header-bottom .wrapper .toggle-btn",
    desktopMethod: "insertAfter",
    breakpoint: 1025,
  }).watch();
}
function accordion() {
  $(".accordion-item.active").find(".accordion-content").show();
  $(".accordion-heading").on("click", function () {
    if (!$(this).parent().is(".active")) {
      $(this)
        .parent()
        .toggleClass("active")
        .children(".accordion-content")
        .slideToggle(500)
        .parent()
        .siblings(".active")
        .removeClass("active")
        .children(".accordion-content")
        .slideToggle(500);
    } else {
      $(this).parent().toggleClass("active");
      $(this).next().slideToggle(500);
    }
  });
}
function dropdownMenu() {
  $(".header .has-mega").hover(function () {
    if ($(this).hasClass("active")) {
      $(this).find(".mega-nav").removeClass("is-hover");
      $(this).removeClass("active");
    } else {
      $(".has-mega").removeClass("active");
      $(this).addClass("active");
      $(this).find(".mega-nav").addClass("is-hover");
    }
  });
  $(document).on("click", ".icon-dropdown", function () {
    $(this).toggleClass("active");
    $(this)
      .parents(".has-mega")
      .addClass("active")
      .find(".mega-nav")
      .addClass("active");
  });
  $(document).on("click", ".nav-back", function () {
    $(".mega-nav").removeClass("active");
    $(this).parents(".has-mega").removeClass("active");
  });
}
function adjustProductAmount() {
  $(".plus").click(function () {
    if ($(this).parents(".amount").find(".input").val() < 10) {
      $(this)
        .parents(".amount")
        .find(".input")
        .val(+$(this).parents(".amount").find(".input").val() + 1);
    }
  });
  $(".minus").click(function () {
    if ($(this).parents(".amount").find(".input").val() > 1) {
      if ($(this).parents(".amount").find(".input").val() > 1)
        $(this)
          .parents(".amount")
          .find(".input")
          .val(+$(this).parents(".amount").find(".input").val() - 1);
    }
  });
}
function jarallax() {
  $(".jarallax").jarallax({
    speed: 0.2,
  });
}
function aboutTabs() {
  $(".about-tabs #tabs-nav li:first-child a").addClass("active");
  $(".about-tabs .option").hide(200);
  $(".about-tabs .option-1").show(200);
  $(function () {
    var selectedClass = "";
    $(".about-tabs #tabs-nav li a").mouseover(function () {
      if ($(this).hasClass("active")) {
        selectedClass = $(this).attr("data-rel");
        $(".about-tabs .option." + selectedClass).hide(200);
      } else {
        selectedClass = $(this).attr("data-rel");
        $(".about-tabs #tabs-nav li a").removeClass("active");
        $(this).addClass("active");
        $(".about-tabs .option").hide(200);
        $(".about-tabs .option." + selectedClass).show(200);
      }
    });
  });
}
function myTabs() {
  $(".my-tabs").each(function () {
    var $this = $(this);
    $this.find(".tab-content:not(:first)").toggle();
    // $(".previous").hide();
    $this.find(".tabs-nav li").click(function () {
      // if ($(this).is(":last-child")) {
      //   $(".next").hide();
      // } else {
      //   $(".next").show();
      // }
      // if ($(this).is(":first-child")) {
      //   $(".previous").hide();
      // } else {
      //   $(".previous").show();
      // }
      var position = $(this).position();
      var corresponding = $(this).data("tab");
      scroll = $(".tabs-nav").scrollLeft();
      $(".tabs-nav").animate(
        {
          scrollLeft: scroll + position.left,
        },
        200
      );
      $(".tabs-container .tab-content").hide();
      $(".tab-content." + corresponding).toggle();
      $(".tabs-nav li").removeClass("active");
      $(this).addClass("active");
    });
    $(".nav-wrap .next").click(function (e) {
      e.preventDefault();
      $(this)
        .parents(".nav-wrap")
        .find("li.active")
        .next("li")
        .trigger("click");
    });
    $(".nav-wrap .prev").click(function (e) {
      e.preventDefault();
      $(this)
        .parents(".nav-wrap")
        .find("li.active")
        .prev("li")
        .trigger("click");
    });
  });
}
function checkboxForm() {
  $(".another-address .checkbox-custom input").click(function () {
    if ($(this).is(":checked")) {
      $(this).parents(".another-address").find(".form-2").show();
    } else {
      $(this).parents(".another-address").find(".form-2").hide();
    }
  });
}
function fixedNav() {
  var nav = $(".header-bottom");
  if (nav.length) {
    var offsetTop = nav.offset().top,
      headerHeight = nav.height(),
      injectSpace = $("<div />", {
        height: headerHeight,
      }).insertAfter(".header");
    injectSpace.hide();
    $(window).on("load scroll", function () {
      if ($(window).scrollTop() > offsetTop) {
        nav.addClass("fixed-hide");
        injectSpace.show();
      } else {
        nav.removeClass("fixed-hide");
        injectSpace.hide();
      }

      if ($(window).scrollTop() > 400) {
        nav.addClass("fixed-show");
      } else {
        nav.removeClass("fixed-show");
      }
    });
  }
}
function productCateFilter() {
  $(".shop-by-categories .list-card").isotope({
    itemSelector: ".card",
  });
  // filter items on button click
  $(".navigation").on("click", ".filter", function () {
    var filterValue = $(this).attr("data-filter");
    $(".list-card").isotope({ filter: filterValue });
    $(".navigation .filter").removeClass("active");
    $(this).addClass("active");
  });
}

function selectUi() {
  $(".custom-select__list").on(
    "click",
    ".custom-select__item.init",
    function () {
      if ($(this).parents(".custom-select").hasClass("open")) {
        $(this).parents(".custom-select").removeClass("open");
        $(this).parent().children(".custom-select__item:not(.init)").hide();
      } else {
        $(".custom-select").removeClass("open");
        $(this).parents(".custom-select").addClass("open");
        $(".custom-select__item:not(.init)").hide();
        $(this).parent().children(".custom-select__item:not(.init)").show();
      }
    }
  );
  var allOptions = $(".custom-select__list").children(
    ".custom-select__item:not(.init)"
  );
  $(".custom-select__list").on(
    "click",
    ".custom-select__item:not(.init)",
    function () {
      allOptions.removeClass("selected");
      $(this).addClass("selected");
      $(this)
        .parents(".custom-select__list")
        .children(".custom-select__item.init")
        .html($(this).html())
        .css("color", "#000");
      $(this)
        .parents(".custom-select__list")
        .children(".custom-select__item:not(.init)")
        .toggle();
      $(this).parents(".custom-select").toggleClass("open");
      $("input#inputInit").val($(this).data("val"));
    }
  );
  var $menu = $(".custom-select");

  $(document).mouseup(function (e) {
    if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
      $menu.removeClass("open");
      $menu.find(".custom-select__item:not(.init)").hide();
    }
  });
}
function checkedActive() {
  $(".dropdown-list input[type=checkbox]").click(function () {
    $(".dropdown-list input[type=checkbox]").each(function () {
      if ($(this).is(":checked")) {
        $(this).parent().addClass("active");
      } else {
        $(this).parent().removeClass("active");
      }
    });
  });
}
function autoComplete() {
  var cate = [
    "Singa Hills, 33 Jalan Singa, 418109",
    "Singapore Post Centre, 0 Singapore Post Centre, 912898",
    "Singapore Post Centre, 0 Singapore Post Centre, 911758",
    "Singapore Post Centre, 0 Singapore Post Centre, 911727",
    "Can’t find your address?",
  ];

  $("#autocomplete").autocomplete({
    source: cate,
  });
}
function productOffset() {
  var headerHeight = $(".header").height();
  $(".product .tabs-nav li").on("click", function () {
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop:
            $(".product .product-categories .tabs-container").offset().top -
            headerHeight,
        },
        500,
        "linear"
      );
  });
}
function imgParallax() {
  var parallaxBox = $(".parallax-box");

  if (parallaxBox.length) {
    $(window).on("load resize", function () {
      parallaxBox.each(function () {
        var wrap = $(this).find(".parallax-wrap"),
          height = [];
        $(this).waitForImages(function () {
          $(this)
            .find(".parallax-item")
            .each(function () {
              height.push(
                parseInt($(this).css("marginTop")) + $(this).height()
              );
            });
          wrap.css("height", Math.max.apply(null, height));
        });
      });
    });
  }
}
function updatePos() {
  $(".slider").each(function () {
    var height = $(this).find(".box-img").outerHeight();
    var btnHeight = $(this).find(".swiper-next").outerHeight();
    $(this)
      .find(".swiper-next,.swiper-prev")
      .css({ top: height / 2 - btnHeight / 2, transform: "none" });
  });
}
function sidebarDropdown() {
  //mega menu
  $(document).on("click", ".sidebar .sidebar-text", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".menu-sub").slideUp(200);
    } else {
      $(".sidebar .sidebar-text").removeClass("active");
      $(this).addClass("active");
      $(".menu-sub").slideUp(200);
      $(this).siblings(".menu-sub").slideDown(200);
    }
  });
}
function rangePrice() {
  $("#price-range").slider({
    range: true,
    min: 0,
    max: 200000,
    values: [0, 200000],
    slide: function (event, ui) {
      $("#priceRange").val("$" + ui.values[0] + " - $" + ui.values[1]);
    },
  });
  $("#priceRange").val(
    "$" +
      $("#price-range").slider("values", 0) +
      " - $" +
      $("#price-range").slider("values", 1)
  );
}
function checkWidth() {
  var $window = $(window);
  var windowsize = $window.width();
  if (windowsize >= 768) {
    $(".sidebar").removeAttr("style");
  }
}
$(window).resize(updatePos).trigger("resize");
$(window).resize(checkWidth).trigger("resize");
$(document).ready(function () {
  App.Init();
  InitSlider();
  Headers();
  fixedNav();
  mappings();
  adjustProductAmount();
  accordion();
  aboutTabs();
  selectUi();
  dropdownMenu();
  sidebarDropdown();
  productCateFilter();
  jarallax();
  imgParallax();
  rangePrice();
  myTabs();
  productOffset();
  autoComplete();
  checkboxForm();
  checkedActive();
  checkWidth();
  updatePos();
  AOS.init({
    once: true,
    duration: 1000, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
  });
});
